export default __webpack_public_path__ + "static/media/yaha-chha.bfe9cac5.png";